export default __webpack_public_path__ + "static/media/triviaicon1.b45ef4a8.png";